import { AppLink } from '@common/components/Link/AppLink';
import { Collection } from '@features/Collection';
import { useSelectCollection } from '@features/Collection/hooks/useSelectedCollectionSelectors';
import { Text } from '@radix-ui/themes';
import { createCollectionDetailsPagePath } from '@router';

interface CollectionTitleCellProps {
    collection: Collection;
}

export const CollectionTitleCell = ({
    collection,
}: CollectionTitleCellProps) => {
    const { selectCollection } = useSelectCollection();
    if (!collection) return;

    const { title, id: collectionId } = collection;

    return (
        <AppLink
            to={createCollectionDetailsPagePath(collectionId)}
            onClick={() => {
                selectCollection(collectionId);
            }}
        >
            <Text color='gray' weight={'medium'}>
                {title}
            </Text>
        </AppLink>
    );
};
